import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import RolesListTopbar from "../../features/manageSubAdmin/rolesTopbar";
import RolesList from "../../features/manageSubAdmin/rolesList";
import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { ROLES } from "../../utils/enums";

const ManageSubadminRoles = () => {

  const navigate = useNavigate();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const user = useAuth()

  useEffect(()=>{
    if(user?.role===ROLES.SUB_ADMIN){
      navigate('/permission-denied',{replace:true})
    }
  },[user])

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Roles</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span>
          {' '} - <span onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</span>
          {' '} - Manage Roles
        </p>
      </div>
      
      <div className="cards">
        <RolesListTopbar  setDebouncedSearchTerm={setDebouncedSearchTerm}  />
        <RolesList debouncedSearchTerm={debouncedSearchTerm} />
      </div>
    </MainContainer>
  );
};

export default ManageSubadminRoles;
